import { useSelector } from "react-redux"
import { Alert } from "@material-ui/lab"
import { useState } from "react"
import { ButtonGroup, Button } from "@material-ui/core"
import TPagos from "."
import TPlanPagos from "../TPlanPagos"
const VistaComrpas = () => {
    const { referencia } = useSelector(store => store.cliente)
    const [tipoPago, setTipoPago] = useState(true)
    const onClick = () => {
        setTipoPago(!tipoPago)
    }
    if (referencia) return (
        <div style={{marginTop: "10px"}}>
            <div style={{ marginBottom: "10px", display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                <ButtonGroup disableElevation variant="contained" color="primary">
                    <Button onClick={onClick} color={tipoPago ? 'secondary' : 'default'} >Depositos</Button>
                    <Button onClick={onClick} color={!tipoPago ? 'secondary' : 'default'} >Plan de pagos</Button>
                </ButtonGroup>
            </div>
            {
                (tipoPago) ? <div>
                    <TPagos />
                </div> : <TPlanPagos />
            }

        </div>
    )
    return (
        <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
    )
}
export default VistaComrpas